import { createSortSchema, createPaginationSchema } from '@emfood/shared';

export const MeasuringMethodRequestsListSearchParamsSchema = createPaginationSchema().concat(
  createSortSchema(['createdAt', 'name', 'description'])
);
